import { render } from "./SendShippingList.vue?vue&type=template&id=b4924bec&scoped=true"
import script from "./SendShippingList.vue?vue&type=script&lang=js"
export * from "./SendShippingList.vue?vue&type=script&lang=js"

import "./SendShippingList.vue?vue&type=style&index=0&id=b4924bec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4924bec"]])

export default __exports__